import { VariableKindPrefix } from '../variables.model'

export function isQuestionnaireVariable(variableId: string) {
  return variableId.startsWith(`${VariableKindPrefix.QUESTIONNAIRE}_`)
}
